import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/all';
import SplitType from 'split-type'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { NavLink } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import { useCallback, useMemo, useRef, useState } from "react";

import FooterComponent from './FooterComponent';
import { Box, Button, Stack, Typography, LinearProgress, Grid, List, ListItem, ListItemText, Container, IconButton, ListItemIcon, Card, CardContent, Paper } from '@mui/material';


import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation } from 'swiper/modules';
import { Biotech, Engineering, FiberManualRecord, Psychology } from '@mui/icons-material';
import ProjectsSection from './ProjectSection';
import TestimonialSection from './TestimonialSection';




gsap.registerPlugin(ScrollTrigger);

const HomeComponent = ({ clickedItem, clickedItem2 }) => {


    // console.log('Clicked Item:', clickedItem);
    // console.log('Clicked Item2:', clickedItem2);

    const aboutRef = useRef(null);
    const homeRef = useRef(null);
    const resumeRef = useRef(null);
    const expRef = useRef(null);
    const projectRef = useRef(null)
    const publicationRef = useRef(null);
    const trainingRef = useRef(null);
    const contactRef = useRef(null);


    useEffect(() => {
        if (clickedItem === "About" && aboutRef.current) {
            aboutRef.current.scrollIntoView({ behavior: "smooth" });
        }
        if (clickedItem === "Home" && homeRef.current) {
            homeRef.current.scrollIntoView({ behavior: "smooth" });
        }
        if (clickedItem === "Resume" && resumeRef.current) {
            resumeRef.current.scrollIntoView({ behavior: "smooth", });
        }
        if (clickedItem === "Publications" && publicationRef.current) {
            publicationRef.current.scrollIntoView({ behavior: "smooth", top: "-10%" });
        }
        if (clickedItem === "Contact" && contactRef.current) {
            contactRef.current.scrollIntoView({ behavior: "smooth", });
        }
    }, [clickedItem]);


    useEffect(() => {
        if (clickedItem2 === "About" && aboutRef.current) {
            aboutRef.current.scrollIntoView({ behavior: "smooth" });
        }
        if (clickedItem2 === "Home" && homeRef.current) {
            homeRef.current.scrollIntoView({ behavior: "smooth" });
        }
        if (clickedItem2 === "Resume" && resumeRef.current) {
            resumeRef.current.scrollIntoView({ behavior: "smooth", });
        }

        if (clickedItem2 === "Publications" && publicationRef.current) {
            publicationRef.current.scrollIntoView({ behavior: "smooth", top: "-10%" });
        }
        if (clickedItem2 === "Contact" && contactRef.current) {
            contactRef.current.scrollIntoView({ behavior: "smooth", });
        }
    }, [clickedItem2]);

    const percentage = 66;

    const containerRef = useRef(null);


    const [init, setInit] = useState(false);


    useEffect(() => {

        AOS.init();


        const myText = new SplitType('.hero-text', { type: 'chars' })
        const chars = myText.chars;
        // console.log(chars);

        const tl = gsap.timeline();

        tl.fromTo(chars, {
            opacity: 0, // Start from opacity 0
            yPercent: 80,
        }, {
            opacity: 1, // Animate to opacity 1
            yPercent: 0, // Animate yPercent to 0
            stagger: 0.1,
            duration: 0.4,
            ease: "power1.inOut",
        });

        // tl.fromTo(".title4", {
        //     opacity: 0,
        //     y: 200,
        // }, {
        //     opacity: 1,
        //     y: 0,
        //     duration: 0.2,
        //     ease: "power1.easeOut",
        // });

        gsap.fromTo(".about-image img", {
            opacity: 0,
            x: -100,
        }, {
            opacity: 1,
            x: 0,
            duration: 10, // Duration of the fade-in effect
            ease: "power1.out",
        });

    }, [])

    const handleScrollDown = () => {
        if (aboutRef.current) {
            aboutRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }


    const handleRefs = (section) => {
        if (section === "about" && aboutRef.current) {
            aboutRef.current.scrollIntoView({ behavior: 'smooth' });
        }
        if (section === "experience" && expRef.current) {
            expRef.current.scrollIntoView({ behavior: 'smooth' });
        }
        if (section === "resume" && resumeRef.current) {
            resumeRef.current.scrollIntoView({ behavior: 'smooth' });
        }
        if (section === "project" && projectRef.current) {
            projectRef.current.scrollIntoView({ behavior: "smooth", });
        }
        if (section === "training" && trainingRef.current) {
            trainingRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const [isLesser992, setIsLesser992] = useState(window.innerWidth <= 992);

    useEffect(() => {
        const handleResize = () => {
            setIsLesser992(window.innerWidth < 992);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const ProfessionalLanguage = [
        { name: 'Python', percentage: 85 },
        { name: 'Java', percentage: 65 },
        { name: 'C, C++', percentage: 60 },
        { name: 'Docker & Azure', percentage: 85 },
        { name: 'Protégé-ontologie', percentage: 80 },
        { name: 'RAG & Data scraping', percentage: 85 },
        { name: 'SQL', percentage: 70 },
        { name: 'AI libraries', percentage: 80 },
        { name: 'NLP, LLM', percentage: 90 },
        { name: 'MongoDB', percentage: 50 },
        { name: 'Node.Js', percentage: 50 },

    ];
    const basicLanguage = [
        { name: 'English', percentage: "Fluent" },
        { name: 'French', percentage: "Above Basic" },
        { name: 'German', percentage: "Basic" },
    ];

    const renderSkills = (title, skills) => (
        <Box sx={{ p: 4, backgroundColor: '#2c3e50', borderRadius: '8px', mb: 4, }}>
            <Typography variant="h5" sx={{ color: '#ecf0f1', mb: 2 }}>{title}</Typography>
            <Grid container spacing={3} >
                {skills.map((skill, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Box >
                            <Stack direction="row" justifyContent='space-between' alignItems="center" spacing={2}>

                                <Typography variant="subtitle1" sx={{ color: '#ecf0f1' }} data-aos="fade-in" data-aos-duration="1000">{skill.name}</Typography>

                                {/* <Typography variant="body2" sx={{ color: '#ecf0f1', textAlign: "right" }}>
                                    {`${skill.percentage}%`}
                                </Typography> */}

                            </Stack>
                            <LinearProgress
                                sx={{
                                    width: '100%',
                                    height: '10px',
                                    borderRadius: '5px',
                                    '& .MuiLinearProgress-bar': {
                                        backgroundColor: '#1abc9c',
                                    },
                                }}
                                variant="determinate"
                                value={skill.percentage}
                            />

                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = '/NapthalineGERARD_Resume.pdf'; // Adjust the path as needed
        link.download = 'NapthalineGERARD_Resume.pdf'; // File name for download
        link.click();
    };


    const benefits = [
        {
            title: "Hands-On Projects",
            desc: "Work on live AI projects from start to deployment."
        },
        {
            title: "Real-World Application",
            desc: "Apply ML, DL, NLP, and LLMs in practical scenarios."
        },
        {
            title: "Professional Mentorship",
            desc: "Guidance on problem-solving, system design, and best practices."
        },
        {
            title: "Collaborative Environment",
            desc: "Experience working in a professional AI setting."
        }
    ];

    const opportunities = [
        "Healthcare Predictive Analytics – Patient outcome prediction models",
        "Medical NLP Systems – Work with unstructured clinical data",
        "Business Intelligence AI – Analytics & automation solutions",
        "Large Language Model Projects – Intelligent assistants & conversational AI"
    ];

    const [swiperRef, setSwiperRef] = useState(null);


    return (
        <Box className="container-2" >


            {/* H E R O */}

            {/* <div className='hero-1' ref={homeRef}> */}


            {/* <img src={require("../Images/my-image.png")} />

<Stack spacing={1} direction="column" sx={{ textAlign: "center" }}>
    <h1 className='hero-text' style={{ color: "white", marginBottom: 30 }}>Napthaline GERARD, Ph.D.</h1>
    <Box
        sx={{
            display: "flex",
            justifyContent: "center",
            mt: 2
        }}
    >
        <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 2, sm: 4 }}
            alignItems="center"
        >
            {[
                {
                    title: "AI Research Engineer",
                    icon: <Psychology fontSize="small" />
                },
                {
                    title: "AI Solutions Specialist",
                    icon: <Engineering fontSize="small" />
                },
                {
                    title: "Clinical & Industrial AI Architect",
                    icon: <Biotech fontSize="small" />
                }
            ].map((role, index) => (
                <Stack
                    key={index}
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{
                        color: "white"
                    }}
                >
                    <IconButton
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            bgcolor: "#eeeeee1a",
                            color: "white",
                            "&:hover": {
                                bgcolor: "#eeeeee1a"
                            }
                        }}
                    >
                        {role.icon}
                    </IconButton>


                    <Typography
                        variant="subtitle1"
                        sx={{
                            fontWeight: 500
                        }}
                    >
                        {role.title}
                    </Typography>
                </Stack>
            ))}
        </Stack>
    </Box>
</Stack>



<Grid
    container
    spacing={2}
    justifyContent="center"
    sx={{ mt: { xs: 5, md: 0 }, p: 2 }}
    data-aos="fade-in"
    maxWidth='lg'
    mx='auto'
>
    {[
        { label: "About", key: "about" },
        { label: "Experience", key: "experience" },
        { label: "Skills", key: "skills" },
        { label: "Projects", key: "project" }
    ].map((item) => (
        <Grid item xs={6} md={3} lg={2} key={item.key}>
            <Button
                fullWidth
                size="large"
                onClick={() => handleRefs(item.key)}
                sx={{
                    color: "white",
                    py: 1.2,
                    borderRadius: 2,
                    fontFamily: `'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif`,
                    textTransform: "none",
                    fontWeight: 500,
                    backgroundColor: "rgba(255,255,255,0.08)",
                    transition: "0.3s ease",
                    "&:hover": {
                        backgroundColor: "rgba(255,255,255,0.25)",
                        transform: "translateY(-2px)"
                    }
                }}
            >
                {item.label}
            </Button>
        </Grid>
    ))}
</Grid> */}



            <Box
                ref={homeRef}
                sx={{
                    minHeight: "90vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    px: 2
                }}
            >
                {/* Image */}
                <Box
                    component="img"
                    src={require("../Images/my-image.png")}
                    alt="Napthaline Gerard"
                    sx={{
                        width: 120,
                        height: 120,
                        borderRadius: "50%",
                        bgcolor: "#728da6b8",
                        objectFit: "contain",
                        mb: 3
                    }}
                />

                {/* Name + Roles */}
                <Stack spacing={2} >
                    <Typography
                        className='hero-text'
                        variant="h3"
                        sx={{
                            color: "white",
                            fontWeight: 500
                        }}
                    >
                        Napthaline GERARD, Ph.D.
                    </Typography>

                    <Stack
                        direction={{ xs: "column", sm: "row" }}
                        spacing={{ xs: 2, sm: 4 }}
                        alignItems="center"
                        justifyContent="center"
                        flexWrap="wrap"
                    >
                        {[
                            {
                                title: "AI Research Engineer",
                                icon: <Psychology fontSize="small" />
                            },
                            {
                                title: "AI Solutions Specialist",
                                icon: <Engineering fontSize="small" />
                            },
                            {
                                title: "Clinical & Industrial AI Architect",
                                icon: <Biotech fontSize="small" />
                            }
                        ].map((role, index) => (
                            <Stack
                                key={index}
                                direction="row"
                                spacing={1}
                                alignItems="center"
                                sx={{ color: "white" }}
                            >
                                <IconButton
                                    size="small"
                                    sx={{
                                        bgcolor: "rgba(255,255,255,0.1)",
                                        color: "white",
                                        "&:hover": {
                                            bgcolor: "rgba(255,255,255,0.15)"
                                        }
                                    }}
                                >
                                    {role.icon}
                                </IconButton>

                                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                    {role.title}
                                </Typography>
                            </Stack>
                        ))}
                    </Stack>
                </Stack>

                {/* Navigation Buttons */}
                <Grid
                    container
                    spacing={2}
                    justifyContent="center"
                    sx={{ mt: 5, maxWidth: 800 }}
                >
                    {[
                        { label: "About", key: "about" },
                        { label: "Experience", key: "experience" },
                        { label: " Mentorship", key: "training" },
                        { label: "Projects", key: "project" }
                    ].map((item) => (
                        <Grid item xs={6} sm={3} key={item.key}>
                            <Button
                                fullWidth
                                size="large"
                                onClick={() => handleRefs(item.key)}
                                sx={{
                                    color: "white",
                                    py: 1.2,
                                    borderRadius: 2,
                                    textTransform: "none",
                                    fontWeight: 500,
                                    backgroundColor: "rgba(255,255,255,0.08)",
                                    transition: "0.3s ease",
                                    "&:hover": {
                                        backgroundColor: "rgba(255,255,255,0.25)",
                                        transform: "translateY(-2px)"
                                    }
                                }}
                            >
                                {item.label}
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            </Box>



            <div style={{ height: "20px" }}>

            </div>

            {/* A B O U T */}

            <div className="p-child-container2" ref={aboutRef}>
                <Container maxWidth="lg" mx='auto' sx={{ overflowX: "hidden" }}>

                    {/* Section Title */}

                    <Typography variant='h4' align='left' sx={{ fontWeight: 900, py: 3, color: "white", fontFamily: `'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif`, }}> About</Typography>

                    <Stack
                        spacing={6}
                        direction={{ xs: "column", md: "row" }}
                        alignItems="center"
                    >

                        {/* Image Section */}
                        <Box sx={{ width: { xs: "100%", md: "50%" }, textAlign: "center" }}>
                            <Box
                                component="img"
                                src={require("../Images/bg-img.png")}
                                alt="About"
                                sx={{
                                    width: "100%",
                                    maxWidth: 420,
                                    borderRadius: 3,
                                    objectFit: "cover"
                                }}
                            />
                        </Box>

                        {/* Content Section */}
                        <Box sx={{ width: { xs: "100%", md: "50%" } }}>

                            <Typography
                                variant="p"
                                component='div'
                                sx={{
                                    color: "#e0e0e0",
                                    mb: 3,
                                }}
                                data-aos="fade-left"
                            >
                                I am an AI Research Engineer specializing in designing intelligent systems
                                that create real-world impact across multiple domains, including healthcare,
                                business, and technology. My focus is on transforming complex data into
                                actionable insights that drive innovation, efficiency, and smarter decision-making.
                            </Typography>

                            <Typography
                                variant="p"
                                component='div'
                                sx={{
                                    color: "#e0e0e0",
                                    mb: 3,
                                }}
                                data-aos="fade-left"

                            >
                                I design and deploy AI solutions for diverse challenges, from predictive
                                modeling and clinical decision support in healthcare, to natural language
                                understanding, recommendation systems, and automated analytics in other
                                industries. My expertise spans ML, DL, NLP, and LLMs — applied with scientific rigor
                                and production-ready engineering.
                            </Typography>

                            <Typography
                                variant="subtitle1"
                                sx={{ fontWeight: 600, color: "white", mb: 1 }}
                            >
                                As a Freelance AI Consultant, I deliver:
                            </Typography>

                            <List dense sx={{ color: "#e0e0e0", mb: 3 }}>
                                {[
                                    "AI-powered decision systems across industries",
                                    "Predictive analytics for business & healthcare",
                                    "NLP solutions for unstructured data",
                                    "LLM-driven intelligent assistants",
                                    "Research-to-production AI pipelines"
                                ].map((service, index) => {
                                    const baseDelay = 300;
                                    const stepDelay = 150;

                                    return (
                                        <ListItem
                                            key={index}
                                            disablePadding
                                            data-aos="fade-up"
                                            data-aos-delay={baseDelay + index * stepDelay}
                                            sx={{ alignItems: "flex-start" }}
                                        >
                                            <ListItemIcon
                                                sx={{
                                                    minWidth: 28,
                                                    mt: "12px",
                                                    color: "#e0e0e0"
                                                }}
                                            >
                                                <FiberManualRecord sx={{ fontSize: 8 }} />
                                            </ListItemIcon>

                                            <ListItemText
                                                primary={service}
                                                primaryTypographyProps={{
                                                    sx: {
                                                        fontSize: "0.95rem",
                                                        lineHeight: 1.8
                                                    }
                                                }}
                                            />
                                        </ListItem>
                                    );
                                })}
                            </List>



                            <Typography
                                variant="p"
                                component='div'
                                sx={{
                                    color: "#e0e0e0",
                                    mb: 4
                                }}
                                data-aos="fade-up"

                            >
                                Beyond building systems, I mentor students and professionals focusing on
                                advanced system design, responsible AI development, and real-world impact.
                            </Typography>

                            <Typography
                                variant="subtitle1"
                                sx={{ fontWeight: 600, color: "white", mb: 1 }}
                            >
                                My mission:
                            </Typography>

                            {/* <Typography
                                variant="p"
                                component='div'
                                sx={{
                                    color: "#e0e0e0",
                                    textAlign: "justify",
                                    mb: 4
                                }}
                            > */}

                            <Typography
                                variant="body2"
                                sx={{
                                    fontStyle: "italic",
                                    mt: 1,
                                    p: 2,
                                    borderRadius: 2,
                                    backgroundColor: "rgba(77,182,255,0.08)",
                                    borderLeft: "4px solid #4db6ff",
                                    color: "#e3f2fd",
                                    mb: 4
                                }}
                            >

                                To build reliable AI systems that solve meaningful problems and drive innovation across industries.
                            </Typography>

                            {/* Button */}
                            <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
                                <Button
                                    variant="contained"
                                    onClick={handleDownload}
                                    sx={{
                                        px: 4,
                                        py: 1.5,
                                        fontWeight: 600,
                                        bgcolor: "white",
                                        color: "black",
                                        borderRadius: 2,
                                        "&:hover": {
                                            bgcolor: "transparent",
                                            color: "white",
                                            border: "1px solid white"
                                        }
                                    }}
                                >
                                    Download CV
                                </Button>
                            </Box>

                        </Box>

                    </Stack>

                </Container>
            </div>


            {/* R E S U M E */}

            <div className='p-child-container2' ref={expRef}>
                <Container maxWidth="xl" mx='auto'>

                    {/* <Typography variant='h4' align='left' sx={{ fontWeight: 900, color: "white", fontFamily: `'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif`, letterSpacing: "5px" }}> My Resume</Typography> */}
                    <div className='resume-content'>


                        <section id="resume" className="resume">
                            <div className="container">

                                <div className="row">
                                    <div className="col-lg-6">
                                        <Typography variant='h4' align='left' sx={{ mb: 5, fontWeight: 900, color: "white", fontFamily: `'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif`, }}> Professional Experience</Typography>

                                        <div className="resume-item" style={{ color: "white" }}>
                                            <h4 >Freelance </h4>
                                            <h5 data-aos="fade-right" data-aos-duration="1500">AI Research Engineer – Mar 2025 – Present</h5>
                                            <p><em>Paris, France </em></p>
                                            <p>
                                            </p>
                                            <ul>
                                                <div >
                                                    <span style={{ fontWeight: 600 }}>Conversational AI & Voice Assistant : &nbsp; </span>

                                                    <li style={{ marginTop: "20px" }}>
                                                        Developed a custom NLP & LLM-based conversational AI for a healthcare SaaS platform with voice and text support.
                                                        <br />
                                                    </li>
                                                    <li>
                                                        Enabled appointment scheduling, doctor recommendations, and symptom-based triage to streamline patient interactions.
                                                        <br />
                                                    </li>
                                                    <li style={{ marginBottom: "20px" }}>
                                                        Enhanced user experience through intelligent, context-aware virtual assistance.
                                                        <br />
                                                    </li>
                                                </div>
                                                <div>
                                                    <span style={{ fontWeight: 600 }}>Intelligent Event Management & Support System Chatbot : &nbsp; </span>

                                                    <li style={{ marginTop: "20px" }}>
                                                        Developed a custom AI-driven platform with RAG architecture to streamline event scheduling, notifications, and attendee management.
                                                        <br />
                                                    </li>
                                                    <li>
                                                        Leveraged NLP and LLM models to automate event communications and intelligent query handling.
                                                        <br />
                                                    </li>
                                                    <li style={{ marginBottom: "20px" }}>
                                                        Enhanced user engagement through context-aware recommendations, reminders, and interactive support powered by retrieval-augmented responses.
                                                        <br />
                                                    </li>
                                                </div>

                                            </ul>
                                            <p />
                                        </div>

                                        <div className="resume-item" style={{ color: "white" }}>
                                            <h4 >Ecole Centrale de Lille</h4>
                                            <h5 data-aos="fade-right" data-aos-duration="1500">Doctoral Researcher – Oct 2021 to Sept 2024</h5>
                                            <p><em>France </em></p>
                                            <p>
                                            </p><ul>
                                                <li>Developed Symbolic and Sub-Symbolic AI modules .</li>
                                                <li>Clinical Data analysation using Machine Learning. </li>
                                                <li>Medical Image processing using Neural networks and U-Net.</li>
                                                <li>Integrating different AI modules and Grad-CAM activation function.</li>
                                            </ul>
                                            <p />
                                        </div>
                                        <div className="resume-item" style={{ color: "white" }}>
                                            <h4>CRIStAL Laboratory- OSL team Lille</h4>
                                            <h5 data-aos="fade-right" data-aos-duration="1500">Intern - March 2021 to August 2021</h5>
                                            <p><em>France</em></p>
                                            <p>
                                            </p><ul>
                                                <li>Designing an AI Ontology for Genetic Diseases utilizing Semantic Reasoning in Protégé.</li>
                                                <li>Developed a Machine Learning model for processing Medical Images.
                                                </li>
                                            </ul>
                                            <p />
                                        </div>

                                        <div className="resume-item" style={{ color: "white" }}>
                                            <h4>Mahatma Gandhi Medical College and Research Institute Puducherry
                                            </h4>
                                            <h5 data-aos="fade-right" data-aos-duration="1500">Intern - June 2017 to August 2017</h5>
                                            <p><em>India</em></p>
                                            <p>
                                            </p><ul>
                                                <li>Maintained, calibrated, and tested biomedical equipment in ICU, CCU, OT, Radiology, Simulation Center,and Emergency Medicine.</li>
                                            </ul>
                                            <p />
                                        </div>

                                    </div>

                                    <div className="col-lg-6">
                                        <h3 className="resume-title" style={{ color: "white" }}>Education</h3>
                                        <div className="resume-item" style={{ color: "white" }}>
                                            <h4 style={{ textTransform: "none" }}>PhD</h4>
                                            <h5 data-aos="fade-right" data-aos-duration="1500">From October 2021 to October 2024</h5>
                                            <p><em> CRIStAL Laboratory - OSL team & Ecole Centrale de
                                                Lille. Lille, France</em></p>
                                            <p>AI module development, Data processing, Data analyzation and Integration of AI modules.</p>
                                            {/* <ul>

                                            <li>
                                                Explainable Hybrid Artificial Intelligence to Predict Pulmonary Tuberculosis
                                                Integrating Ontology and Deep learning.
                                            </li>
                                            <li>Decision support system & Decision making knowledge system.</li>
                                            <li>Deep neural classification & Chest X-ray lesion classification.</li>
                                            <li>Grad-CAM activation function.</li>
                                        </ul> */}
                                        </div>
                                        <div className="resume-item" style={{ color: "white" }}>
                                            <h4>Master - International Biomedical Engineering. </h4>
                                            <h5 data-aos="fade-right" data-aos-duration="1500">From September 2019 to July 2021</h5>
                                            <p><em>Ecole centrale de lille. Lille, France</em></p>
                                            <p>Medical Science, Bio Computation, Medical Imaging, Medical Devices Development, Surgical implants, Signal Processing  and Project management.
                                            </p>
                                            {/* <ul>
                                            <li>
                                                Bionic Hand design in CAD using anatomy principle.
                                            </li>
                                            <li>
                                                Foot prosthesis in CAD.
                                            </li>
                                            <li>
                                                Design of optical pulse Oximeter.
                                            </li>
                                        </ul> */}
                                        </div>
                                        <div className="resume-item" style={{ color: "white" }}>
                                            <h4>B.Tech - Computer science Engineering</h4>
                                            <h5 data-aos="fade-right" data-aos-duration="1500"> From August 2015 to
                                                May 2019</h5>
                                            <p><em>Rajiv Gandhi College of Engineering and
                                                Technology Puducherry, India</em></p>
                                            <p>Study  of computation, algorithms, programming languages, program
                                                design, software, hardware, etc.</p>
                                            {/* <ul>

                                            <li>
                                                SAM (Smart Agriculture Monitoring) system using IOT.
                                            </li>
                                            <li>
                                                Chest Radiographic diagnosis of Pulmonary Tuberculosis using
                                                Image processing technique in a Hospital.
                                            </li>
                                        </ul> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {
                            isLesser992 &&
                            <>
                                <br />

                                <div className='p-child-container4-languages' >
                                    <div className='container4-child1' style={{ justifyContent: "start" }}>
                                        <h3 style={{ fontSize: "xx-large", fontWeight: "900", color: "white", fontFamily: `'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif`, letterSpacing: "5px", padding: "60px" }}>Skills</h3>
                                    </div>
                                    <div className='container4-child2-languages' >
                                        <Box sx={{ width: '100%', p: 3, display: "grid", backgroundColor: "#2c3e50" }}>
                                            <Stack direction="column" spacing={2} >
                                                <em style={{ color: "white" }}> Professional </em>
                                                {ProfessionalLanguage.map((skill, index) => (
                                                    <Box key={index} >
                                                        <Typography variant="subtitle1" data-aos="fade-right" data-aos-duration="1000">{skill.name}</Typography>
                                                        {/* <Typography variant="body2" sx={{ color: '#ecf0f1', textAlign: "right" }}>
                                                            {`${skill.percentage}%`}
                                                        </Typography> */}
                                                        <LinearProgress sx={{ height: "10px", borderRadius: "7px" }} variant="determinate" value={skill.percentage} />
                                                    </Box>
                                                ))}
                                            </Stack>
                                        </Box>
                                        <br />
                                        <div className='container4-child1' style={{ justifyContent: "start" }}>
                                            <h3 style={{ fontSize: "xx-large", fontWeight: "900", color: "white", fontFamily: `'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif`, letterSpacing: "5px", padding: "60px" }}>Languages</h3>
                                        </div>
                                        <Box sx={{ p: 4, backgroundColor: '#2c3e50', borderRadius: '8px', mb: 4 }}>
                                            <Typography variant="h6" sx={{ color: '#ecf0f1', mb: 2 }}>
                                                Professional
                                            </Typography>

                                            <Grid container spacing={3}>
                                                {[
                                                    { name: "English", value: 80, level: "Fluent" },
                                                    { name: "French", value: 50, level: "Above Basic" },
                                                    { name: "German", value: 50, level: "Basic" }
                                                ].map((lang, index) => (
                                                    <Grid item xs={12} sm={4} key={index}>
                                                        <Stack spacing={2}>
                                                            <Typography
                                                                variant="subtitle1"
                                                                sx={{ color: '#ecf0f1' }}
                                                                data-aos="fade-in"
                                                                data-aos-duration="1000"
                                                            >
                                                                {lang.name}
                                                            </Typography>

                                                            <Stack direction="row" alignItems="center" spacing={2}>
                                                                <LinearProgress
                                                                    variant="determinate"
                                                                    value={lang.value}
                                                                    sx={{
                                                                        width: '200px',
                                                                        height: '10px',
                                                                        borderRadius: '5px',
                                                                        backgroundColor: 'rgba(255,255,255,0.2)',
                                                                        '& .MuiLinearProgress-bar': {
                                                                            backgroundColor: '#1abc9c',
                                                                        },
                                                                    }}
                                                                />

                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{ color: '#ecf0f1', textAlign: "start" }}
                                                                >
                                                                    {lang.level}
                                                                </Typography>
                                                            </Stack>
                                                        </Stack>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Box>
                                    </div>
                                </div>


                            </>
                        }

                        {
                            !isLesser992 &&
                            <Container maxWidth='xl' mx='auto' >
                                <br />

                                {/* <div className='p-child-container4-languages' > */}
                                <Typography variant='h4' align='left' sx={{ fontWeight: 900, color: "white", fontFamily: `'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif`, }}> Skills</Typography>


                                {/* <div className='container4-child2-languages'> */}
                                <Box sx={{ p: 5, width: "100%", display: "flex", flexDirection: "column", justifyContent: "space-around" }}>
                                    {renderSkills('Professional', ProfessionalLanguage)}
                                </Box>

                                <Typography variant='h4' align='left' sx={{ fontWeight: 900, color: "white", fontFamily: `'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif`, }}> Languages</Typography>

                                <Box sx={{ p: 5, width: "100%", display: "flex", flexDirection: "column", justifyContent: "space-around" }}>
                                    <Box sx={{ p: 4, backgroundColor: '#2c3e50', borderRadius: '8px', mb: 4 }}>
                                        <Typography variant="h6" sx={{ color: '#ecf0f1', mb: 2 }}>
                                            Professional
                                        </Typography>

                                        <Grid container spacing={3}>
                                            {[
                                                { name: "English", value: 80, level: "Fluent" },
                                                { name: "French", value: 50, level: "Above Basic" },
                                                { name: "German", value: 50, level: "Basic" }
                                            ].map((lang, index) => (
                                                <Grid item xs={12} sm={4} key={index}>
                                                    <Stack spacing={2}>
                                                        <Typography
                                                            variant="subtitle1"
                                                            sx={{ color: '#ecf0f1' }}
                                                            data-aos="fade-in"
                                                            data-aos-duration="1000"
                                                        >
                                                            {lang.name}
                                                        </Typography>

                                                        <Stack direction="row" alignItems="center" spacing={2}>
                                                            <LinearProgress
                                                                variant="determinate"
                                                                value={lang.value}
                                                                sx={{
                                                                    width: '200px',
                                                                    height: '10px',
                                                                    borderRadius: '5px',
                                                                    backgroundColor: 'rgba(255,255,255,0.2)',
                                                                    '& .MuiLinearProgress-bar': {
                                                                        backgroundColor: '#1abc9c',
                                                                    },
                                                                }}
                                                            />

                                                            <Typography
                                                                variant="body2"
                                                                sx={{ color: '#ecf0f1', textAlign: "start" }}
                                                            >
                                                                {lang.level}
                                                            </Typography>
                                                        </Stack>
                                                    </Stack>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Box>
                                </Box>

                                {/* </div> */}
                                {/* </div> */}


                            </Container>
                        }

                    </div>
                </Container>
            </div>


            {/* M E N T O R S H I P */}

            <Box
                ref={trainingRef}
                sx={{
                    py: 12,
                    borderRadius: 8,
                    // background: "linear-gradient(135deg, #1d4468 0%, #163a5a 100%)"
                }}
            >
                <Container maxWidth="lg">

                    {/* Header Section */}
                    <Box textAlign="left" mb={8}>
                        <Typography variant='h4' align='left' sx={{ fontWeight: 900, color: "white", fontFamily: `'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif`, }}>
                            Mentorship & Live Projects
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{ color: "#cfd8dc", mb: 3, fontFamily: "italic" }}
                        >
                            Learn by Doing | Gain Hands-On AI Experience
                        </Typography>

                        <Typography
                            sx={{
                                color: "#e0e0e0",
                                maxWidth: "750px",
                                // margin: "0 auto",
                                backdropFilter: `blur(3px)`,
                                lineHeight: 1.8
                            }}
                        >
                            I’m passionate about helping students and aspiring AI professionals go beyond theory. If you want to gain real-world experience working on live AI projects, I offer mentorship and project guidance across healthcare, business, and technology domains.
                        </Typography>
                    </Box>

                    {/* Two Column Section */}
                    <Grid container spacing={6}>

                        {/* Benefits */}
                        <Grid item xs={12} md={6}>
                            <Typography variant='h5' align='left' sx={{ mb: 2, fontWeight: 900, color: "white", fontFamily: `'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif`, }}>
                                How You’ll Benefit:
                            </Typography>

                            <Stack spacing={3}>
                                {[
                                    "Hands-On Projects: Work on live AI projects from start to deployment.",
                                    "Real-World Application: Apply ML, DL, NLP, and LLMs in practical scenarios.",
                                    "Professional Mentorship: Receive guidance on problem-solving, system design, and best practices.",
                                    "Collaborative Environment: Experience working in a professional AI setting."
                                ].map((text, i) => (
                                    <Paper
                                        key={i}
                                        elevation={0}
                                        sx={{
                                            p: 3,
                                            borderRadius: 3,
                                            backgroundColor: "rgba(255,255,255,0.06)",
                                            backdropFilter: "blur(20px)",
                                            color: "#e0e0e0"
                                        }}
                                    >
                                        <Typography variant='subtitle1' sx={{ lineHeight: 1.7 }}>
                                            {text}
                                        </Typography>
                                    </Paper>
                                ))}
                            </Stack>
                        </Grid>

                        {/* Opportunities */}
                        <Grid item xs={12} md={6}>
                            <Typography variant='h5' align='left' sx={{ mb: 2, fontWeight: 900, color: "white", fontFamily: `'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif`, }}>
                                Sample Opportunities:
                            </Typography>

                            <Stack spacing={3}>
                                {[
                                    "Healthcare Predictive Analytics – Build models for patient outcome prediction.",
                                    "Medical NLP Systems – Work with unstructured clinical data.",
                                    "Business Intelligence AI – Develop AI solutions for analytics and automation.",
                                    "Large Language Model Projects – Create intelligent assistants and conversational AI."
                                ].map((text, i) => (
                                    <Paper
                                        key={i}
                                        elevation={0}
                                        sx={{
                                            p: 3,
                                            borderRadius: 3,
                                            backgroundColor: "rgba(255,255,255,0.06)",
                                            backdropFilter: "blur(6px)",
                                            color: "#e0e0e0"
                                        }}
                                    >
                                        <Typography variant='subtitle1' sx={{ lineHeight: 1.7 }}>
                                            {text}
                                        </Typography>
                                    </Paper>
                                ))}
                            </Stack>
                        </Grid>
                    </Grid>

                    <TestimonialSection />


                    {/* Closing + CTA */}
                    <Box textAlign="center" mt={10}>
                        <Typography
                            sx={{
                                color: "#e0e0e0",
                                maxWidth: "750px",
                                margin: "0 auto",
                                lineHeight: 1.8,
                                mb: 4
                            }}
                        >
                            Interested in joining? Let’s get you involved in a project that makes an impact. Contact me, and I’ll connect with you to discuss the opportunity.
                        </Typography>

                        <Button
                            variant="contained"
                            size="large"
                            onClick={() => {
                                window.scrollTo({
                                    top: document.body.scrollHeight,
                                    behavior: "smooth"
                                });
                            }}
                            sx={{
                                px: 6,
                                py: 1.8,
                                fontWeight: 600,
                                borderRadius: 3,
                                backgroundColor: "white",
                                color: "#1d4468",
                                boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
                                "&:hover": {
                                    backgroundColor: "#f0f0f0",
                                    transform: "translateY(-3px)"
                                },
                                transition: "all 0.3s ease"
                            }}
                        >
                            Contact Me
                        </Button>

                    </Box>

                </Container>
            </Box>

            {/* P R O J E C T S*/}

            <Box ref={projectRef}>
                <ProjectsSection />

            </Box>


            {/* P O R T F O L I O */}
            <Box ref={publicationRef} sx={{ px: 2, py: 5, bgcolor: "#1d374f", }}>
                <Box maxWidth='lg' mx='auto'>

                    <Typography variant='h4' align='left' sx={{ mb: 4, fontWeight: 900, color: "white", fontFamily: `'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif`, }}>
                        Conference & Journal
                    </Typography>
                    <Box sx={{ mt: 3 }}>
                        <ol style={{ paddingLeft: "1.5rem", color: "white" }}>
                            {[
                                {
                                    title:
                                        "Deep learning system to diagnose Pulmonary Tuberculosis using chest X-ray, ISERD International Conference, Dubai, January 2024.",
                                    link: "https://drive.google.com/file/d/1_7nK4hL2iLGSs1qW60pM5JKJnvpOeWKq/view?usp=drivesdk"
                                },
                                {
                                    title:
                                        "Symbolic Artificial Intelligence to Diagnose Tuberculosis Using Ontology, International Medical conference, Medinfo, Australia, July 2023.",
                                    link: "https://pubmed.ncbi.nlm.nih.gov/38426879/"
                                },
                                {
                                    title:
                                        "Chest Radiographic diagnosis of Pulmonary Tuberculosis using Image processing technique in Android Application, Journal of JETIR, India, March 2019.",
                                    link: "http://www.jetir.org/papers/JETIRAK06013.pdf"
                                }
                            ].map((item, index) => (
                                <li key={index} style={{ marginBottom: "1.5rem" }}>

                                    <Typography variant="body1" sx={{ mb: 1, }}>
                                        {item.title}
                                    </Typography>

                                    <Button
                                        variant="contained"
                                        size="small"
                                        href={item.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{
                                            textTransform: "none",
                                            borderRadius: 2
                                        }}
                                    >
                                        Click here to read more
                                    </Button>

                                </li>
                            ))}
                        </ol>
                    </Box>

                </Box>
            </Box>

            <Box
                maxWidth='lg' mx='auto'
                sx={{
                    mb: 12,
                    px: { xs: 2, md: 2 },
                    py: 4,
                    borderRadius: 2,
                }}
            >
                {/* Section Label */}
                {/* <Typography
                    variant="overline"
                    sx={{
                        letterSpacing: 2,
                        color: "rgba(255,255,255,0.6)",
                    }}
                >
                    Academic Contribution
                </Typography> */}

                {/* Main Heading */}
                <Typography
                    variant="h4"
                    sx={{
                        mt: 1,
                        mb: 3,
                        fontWeight: 800,
                        color: "#fff",
                        fontFamily: `'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif`,
                    }}
                >
                    Doctoral Thesis
                </Typography>

                {/* Description */}
                <Typography
                    variant="body1"
                    sx={{
                        color: "rgba(255,255,255,0.8)",
                        maxWidth: 700,
                        lineHeight: 1.8,
                        mb: 4,
                    }}
                >
                    A comprehensive overview of my doctoral research, including methodology,
                    experimental framework, and key findings, is publicly available through
                    the official academic archive.
                </Typography>

                {/* CTA Button */}
                <Button
                    variant="outlined"
                    href="https://theses.fr/2024CLIL0020"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        textTransform: "none",
                        fontWeight: 600,
                        px: 4,
                        py: 1.2,
                        borderColor: "rgba(255,255,255,0.3)",
                        color: "#fff",
                        "&:hover": {
                            borderColor: "#fff",
                            backgroundColor: "rgba(255,255,255,0.05)",
                        },
                    }}
                >
                    View Full Thesis
                </Button>
            </Box>

            {/* C O N T A C T */}
            {/* <div className='p-child-container5' ref={contactRef}>
                <div className='container5-child1' >
                    <h1 className='contact-title-head'>Contact</h1>
                </div>
                <div className='container5-child2'>
                    <ContactComponent />

                </div>
            </div> */}
            <FooterComponent />

        </Box >

    );
};

export default HomeComponent;